import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seguradoras',
  template: require('./seguradoras.component.html')
})
export class SeguradorasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguradoras/seguradoras.component.ts
 **/